import React from "react";
import {connect} from "react-redux";

class Notification extends React.Component {
    render() {
        return <table className="table">
            <thead>
            <tr>
                <th scope="col">Notifications</th>
            </tr>
            </thead>
            <tbody>
            {this.props.auth.unread_notifications &&
            Object.keys(this.props.auth.unread_notifications).map((k) => (
                <tr key={this.props.auth.unread_notifications[k].id}>
                    <td dangerouslySetInnerHTML={{__html: this.props.auth.unread_notifications[k].readable_html}}/>
                </tr>
            ))}
            {this.props.auth.unread_notifications !== undefined &&
            !this.props.auth.unread_notifications.length
            &&
            <tr>
                <td>Great! You are free of all notifications.</td>
            </tr>
            }
            </tbody>
        </table>;
    }
}


const mapStateToProps = (store) => {
    return {auth: store.entities.auth}
}

export default connect(mapStateToProps)(Notification)
